export default __webpack_public_path__ + "static/logo_transparent-a0e48487fffd4b798f7c819955323ba1.png";